import { render, staticRenderFns } from "./EditDialog_Sorts.vue?vue&type=template&id=2ab500c0&scoped=true"
import script from "./EditDialog_Sorts.vue?vue&type=script&lang=js"
export * from "./EditDialog_Sorts.vue?vue&type=script&lang=js"
import style0 from "./EditDialog_Sorts.vue?vue&type=style&index=0&id=2ab500c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab500c0",
  null
  
)

export default component.exports